import { render, staticRenderFns } from "./VillageNavMobile.vue?vue&type=template&id=07fc76f8&scoped=true"
import script from "./VillageNavMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./VillageNavMobile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VillageNavMobile.vue?vue&type=style&index=0&id=07fc76f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc76f8",
  null
  
)

export default component.exports